import React from 'react';

function Team() {
  return (
    <>
      <section id="team" className="team section">
        {/* Section Title */}
        <div className="container section-title" data-aos="fade-up">
          <h2>Team</h2>
          <p>Meet the passionate professionals driving our mission forward with expertise and dedication.</p>
        </div>

        <div className="container">
          <div className="row gy-4">
            {[
              { name: "AC Mansoor Khan", title: "Chairman & Founder", img: "/assets/img/team/team-4a.jpg" },
              { name: "Nasar", title: "Chief Executive Officer (CEO)", img: "/assets/img/team/team-1.jpeg" },
              { name: "Salim AC", title: "Chief Operating Officer (COO)", img: "/assets/img/team/team-3ab.jpg" },
              { name: "Sajir Muhammed", title: "General Manager (GM)", img: "/assets/img/team/team-2a.jpg" }
            ].map((member, idx) => (
              <div key={idx} className="col-lg-3 col-md-6 d-flex align-items-stretch" data-aos="fade-up" data-aos-delay={(idx + 1) * 100}>
                <div className="team-member">
                  <div className="member-img">
                    <img src={member.img} className="img-fluid" alt={member.name} />
                  </div>
                  <div className="member-info" style={{ textAlign: 'center', marginTop: '10px' }}>
                    <h4>{member.name}</h4>
                    <span>{member.title}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}

export default Team;
